<div class="employees-page">

  <div class="toast show" *ngIf="toastMessage" [class.success]="toastKind === 'success'"
    [class.error]="toastKind === 'error'" [class.warning]="toastKind === 'info'" (click)="clearToast()" role="status"
    aria-live="polite">
    <img class="icon"
      [src]="toastKind === 'success' ? '/success.png' : toastKind === 'error' ? '/fail.png' : '/warning.png'" alt=""
      aria-hidden="true" />

    <div class="toast-title">
      {{ toastKind === 'success' ? 'Success' : toastKind === 'error' ? 'Action needed' : 'Notice' }}
    </div>

    <div class="toast-body">{{ toastMessage }}</div>
  </div>

  <main class="employees-shell">
    <section class="employees-hero" *ngIf="!isLoading">
      <div class="hero-copy">
        <div class="eyebrow">Employee Management</div>
        <h1>Employees</h1>
        <p>Manage employee records, status, assignments, imports, and profile configuration.</p>
      </div>

      <div class="hero-actions">
        <button class="action-btn secondary" type="button" (click)="goToImport()">
          <span class="btn-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <path d="m17 8-5-5-5 5" />
              <path d="M12 3v12" />
            </svg>
          </span>
          Import
        </button>

        <button class="action-btn secondary" type="button" (click)="exportEmployeesToExcel()"
          [disabled]="isExportingEmployees">
          <span class="btn-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />
              <path d="M7 10l5 5 5-5" />
              <path d="M12 15V3" />
            </svg>
          </span>
          {{ isExportingEmployees ? 'Exporting...' : 'Export' }}
        </button>

        <button class="action-btn primary" type="button" (click)="openCreateModal()">
          <span class="btn-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 5v14" />
              <path d="M5 12h14" />
            </svg>
          </span>
          New Employee
        </button>
      </div>
    </section>

    <section class="employees-card">
      <div class="employees-card-header" *ngIf="!isLoading">
        <div class="tabs-shell" role="tablist" aria-label="Employee views">
          <button type="button" class="view-tab active" routerLink="/employees">
            Employees
            <span class="tab-count">{{ totalEmployeeCount || totalCount || 0 }}</span>
          </button>

          <button type="button" class="view-tab" routerLink="/employees/missing-info">
            Invalid Employees
            <span class="tab-count">{{ missingEmployeeCount || 0 }}</span>
          </button>
        </div>

        <div class="page-size-control">
          <label for="pageSizeTop">Rows</label>
          <select id="pageSizeTop" [(ngModel)]="pageSize" (change)="changePageSize()">
            <option *ngFor="let size of pageSizeOptions" [value]="size">
              {{ size }}
            </option>
          </select>
        </div>
      </div>

      <div class="employee-filters" *ngIf="!isLoading">
        <label class="search-box">
          <span class="search-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
          </span>

          <input type="text" [(ngModel)]="filters.searchTerm" (ngModelChange)="onSearchTermChange($event)"
            placeholder="Search employee name..." />
        </label>

        <label class="filter-field">
          <span>Company</span>
          <select [(ngModel)]="filters.companyId" (ngModelChange)="onCompanyChange($event)">
            <option [ngValue]="null">All companies</option>
            <option *ngFor="let company of filterService.filterValues?.companies" [ngValue]="company.id">
              {{ company.name }}
            </option>
          </select>
        </label>

        <label class="filter-field">
          <span>Department</span>
          <select [(ngModel)]="filters.departmentId" (ngModelChange)="onDepartmentChange($event)">
            <option [ngValue]="null">All departments</option>
            <option *ngFor="let dept of filterService.filterValues?.departments" [ngValue]="dept.id">
              {{ dept.code }} - {{ dept.name }}
            </option>
          </select>
        </label>

        <label class="filter-field">
          <span>Status</span>
          <select [(ngModel)]="filters.employmentStatus" (ngModelChange)="onEmploymentStatusChange($event)">
            <option [ngValue]="null">All statuses</option>
            <option *ngFor="let status of employmentStatusOptions" [ngValue]="status">
              {{ status }}
            </option>
          </select>
        </label>

        <button class="clear-filters-btn" type="button" (click)="clearFilters()" [disabled]="!hasActiveFilters">
          Clear
        </button>
      </div>

      <div class="employees-table-wrap" style="position: relative; min-height: 260px;">
        <div *ngIf="isLoading" class="loading-overlay">
          <div class="spinner"></div>
        </div>

        <ng-container *ngIf="!isLoading && employees.length > 0">
          <table class="employees-table">
            <thead>
              <tr>
                <th>Employee</th>
                <th>Status</th>
                <th>Company</th>
                <th>Department</th>
                <th>Worker Type</th>
                <th>Pay Group</th>
                <th>Shift</th>
                <th></th>
              </tr>
            </thead>

            <tbody>
              <tr *ngFor="let emp of employees" [ngClass]="getEmployeeColorClass(emp)" (click)="openProfile(emp.id)">
                <td>
                  <div class="employee-main">
                    <div class="avatar" [ngClass]="getEmployeeColorClass(emp)">
                      {{ emp.firstName?.[0] || '?' }}{{ emp.lastName?.[0] || '?' }}
                    </div>

                    <div class="identity">
                      <div class="name-line">
                        {{ emp.lastName || '-' }}, {{ emp.firstName || '-' }}
                      </div>

                      <div class="meta-line">
                        <span>#{{ emp.employeeNumber || 'N/A' }}</span>
                        <span>•</span>
                        <span>{{ emp.email || 'No email' }}</span>
                      </div>
                    </div>
                  </div>
                </td>

                <td>
                  <span class="status-pill"
                    [ngClass]="(emp.employmentStatus || emp.employeeStatus || '').toLowerCase()">
                    <span class="status-dot"></span>
                    {{ emp.employmentStatus || emp.employeeStatus || '-' }}
                  </span>
                </td>

                <td>{{ emp.company?.name || '-' }}</td>
                <td>
                  <span *ngIf="emp.department; else noDepartment">
                    {{ emp.department.code }} - {{ emp.department.name }}
                  </span>
                  <ng-template #noDepartment>-</ng-template>
                </td>
                <td>{{ emp.workerType?.name || '-' }}</td>
                <td>{{ emp.payGroup?.name || '-' }}</td>
                <td>{{ emp.shift?.name || '-' }}</td>

                <td>
                  <button class="row-action" type="button" (click)="$event.stopPropagation(); openProfile(emp.id)">
                    View
                    <span aria-hidden="true">→</span>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>

          <div class="employee-mobile-list">
            <button class="employee-mobile-card" type="button" *ngFor="let emp of employees"
              [ngClass]="getEmployeeColorClass(emp)" (click)="openProfile(emp.id)">
              <div class="mobile-card-top">
                <div class="employee-main">
                  <div class="avatar" [ngClass]="getEmployeeColorClass(emp)">
                    {{ emp.firstName?.[0] || '?' }}{{ emp.lastName?.[0] || '?' }}
                  </div>

                  <div class="identity">
                    <div class="name-line">
                      {{ emp.lastName || '-' }}, {{ emp.firstName || '-' }}
                    </div>
                    <div class="meta-line">#{{ emp.employeeNumber || 'N/A' }} • {{ emp.email || 'No email' }}</div>
                  </div>
                </div>

                <span class="status-pill" [ngClass]="(emp.employmentStatus || emp.employeeStatus || '').toLowerCase()">
                  <span class="status-dot"></span>
                  {{ emp.employmentStatus || emp.employeeStatus || '-' }}
                </span>
              </div>

              <div class="mobile-details">
                <div>
                  <span>Company</span>
                  <strong>{{ emp.company?.name || '-' }}</strong>
                </div>

                <div>
                  <span>Department</span>
                  <strong>{{ emp.department?.name || '-' }}</strong>
                </div>

                <div>
                  <span>Pay Group</span>
                  <strong>{{ emp.payGroup?.name || '-' }}</strong>
                </div>

                <div>
                  <span>Shift</span>
                  <strong>{{ emp.shift?.name || '-' }}</strong>
                </div>
              </div>
            </button>
          </div>
        </ng-container>

        <div class="empty-state" *ngIf="!isLoading && employees.length === 0">
          <div class="empty-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <circle cx="11" cy="11" r="8" />
              <path d="m21 21-4.35-4.35" />
            </svg>
          </div>

          <h3>No employees found</h3>
          <p>Adjust your filters or clear the search criteria to see more employees.</p>

          <button class="clear-filters-btn" type="button" (click)="clearFilters()" [disabled]="!hasActiveFilters">
            Clear Filters
          </button>
        </div>
      </div>

      <div class="table-footer" *ngIf="!isLoading">
        <div class="footer-meta">
          Page <strong>{{ currentPage }}</strong> of <strong>{{ totalPages }}</strong>
        </div>

        <div class="pagination">
          <button type="button" (click)="prevPage()" [disabled]="currentPage === 1">
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="m15 18-6-6 6-6" />
            </svg>
            Prev
          </button>

          <button type="button" (click)="nextPage()" [disabled]="currentPage === totalPages">
            Next
            <svg viewBox="0 0 24 24" aria-hidden="true">
              <path d="m9 18 6-6-6-6" />
            </svg>
          </button>
        </div>
      </div>
    </section>
  </main>

  <div class="modal-backdrop" *ngIf="isCreateModalOpen" (click)="closeCreateModal()">
    <div class="modal-panel create-employee-modal" (click)="$event.stopPropagation()" role="dialog" aria-modal="true"
      aria-labelledby="createEmployeeTitle">
      <div class="modal-header">
        <div class="modal-title-wrap">
          <div class="modal-icon" aria-hidden="true">
            <svg viewBox="0 0 24 24">
              <path d="M12 5v14" />
              <path d="M5 12h14" />
            </svg>
          </div>

          <div>
            <h3 id="createEmployeeTitle">Create Employee</h3>
            <p class="modal-subtitle">Add an employee manually.</p>
          </div>
        </div>

        <button class="modal-close-btn" type="button" (click)="closeCreateModal()" [disabled]="isCreatingEmployee"
          aria-label="Close">
          ×
        </button>
      </div>

      <div class="modal-body scrollable">
        <div class="modal-loading" *ngIf="isCreateModalLoading">
          <div class="spinner"></div>
        </div>

        <ng-container *ngIf="!isCreateModalLoading">
          <div class="modal-error-banner" *ngIf="createModalError">
            {{ createModalError }}
          </div>

          <ng-container *ngIf="!createModalError">
            <div class="modal-info-banner">
              {{ createFormHelpText }}
            </div>

            <div class="create-form-grid">
              <label class="form-field" [class.invalid]="isCreateFieldMissing('employeeNumber')">
                <span>Employee # <strong>*</strong></span>
                <input type="text" [(ngModel)]="createForm.employeeNumber" placeholder="Enter employee number" />
              </label>

              <label class="form-field" [class.invalid]="isCreateFieldMissing('firstName')">
                <span>First Name <strong>*</strong></span>
                <input type="text" [(ngModel)]="createForm.firstName" placeholder="Enter first name" />
              </label>

              <label class="form-field">
                <span>Middle Initial</span>
                <input type="text" [(ngModel)]="createForm.middleName" placeholder="Optional" />
              </label>

              <label class="form-field" [class.invalid]="isCreateFieldMissing('lastName')">
                <span>Last Name <strong>*</strong></span>
                <input type="text" [(ngModel)]="createForm.lastName" placeholder="Enter last name" />
              </label>

              <label class="form-field" [class.invalid]="isCreateFieldMissing('hireDate')">
                <span>Hire Date <strong>*</strong></span>
                <input type="date" [(ngModel)]="createForm.hireDate" />
              </label>

              <label class="form-field" [class.invalid]="isCreateFieldMissing('email')">
                <span>Email <strong>*</strong></span>
                <input type="email" [(ngModel)]="createForm.email" placeholder="Enter email address" />
              </label>

              <label class="form-field">
                <span>RFID</span>
                <input type="text" [(ngModel)]="createForm.rfid" placeholder="Optional" />
              </label>

              <div class="form-field phone-form-field" [class.invalid]="isCreateFieldMissing('phoneLocalNumber')">
                <span>Phone <strong>*</strong></span>

                <div class="phone-input-row">
                  <div class="phone-country-select">
                    <app-search-select [options]="countryPhoneCodeOptions" placeholder="Search country..."
                      [(selectedId)]="createForm.phoneCountryIso2"
                      (selectedIdChange)="onCreatePhoneCountryChange($event)">
                    </app-search-select>
                  </div>

                  <div class="phone-local-input-wrap">
                    <input class="phone-local-input" type="tel" inputmode="numeric" autocomplete="tel-national"
                      placeholder="(555) 123-4567" [value]="createPhoneLocalInputValue"
                      (input)="onCreatePhoneLocalNumberInput($any($event.target).value)" />
                  </div>
                </div>
              </div>

              <div class="form-field" [class.invalid]="isCreateFieldMissing('departmentId')">
                <span>Department <strong>*</strong></span>
                <app-search-select [options]="createDepartmentOptions" placeholder="Search departments..."
                  [(selectedId)]="createForm.departmentId">
                </app-search-select>
              </div>

              <div class="form-field">
                <span>Default Overhead WON</span>
                <app-search-select [options]="createOverheadWonOptions" placeholder="Search overhead work orders..."
                  [(selectedId)]="createForm.defaultWorkOrderNumberId">
                </app-search-select>
              </div>

              <div class="form-field" [class.invalid]="isCreateFieldMissing('companyId')">
                <span>Company <strong>*</strong></span>
                <app-search-select [options]="createCompanyOptions" placeholder="Search companies..."
                  [(selectedId)]="createForm.companyId">
                </app-search-select>
              </div>

              <div class="form-field" [class.invalid]="isCreateFieldMissing('payGroupId')">
                <span>Pay Group <strong>*</strong></span>
                <app-search-select [options]="createPayGroupOptions" placeholder="Search pay groups..."
                  [(selectedId)]="createForm.payGroupId">
                </app-search-select>
              </div>

              <div class="form-field" [class.invalid]="isCreateFieldMissing('shiftId')">
                <span>Shift <strong>*</strong></span>
                <app-search-select [options]="createShiftOptions" placeholder="Search shifts..."
                  [(selectedId)]="createForm.shiftId">
                </app-search-select>
              </div>

              <div class="form-field" [class.invalid]="isCreateFieldMissing('workerTypeId')">
                <span>Worker Type <strong>*</strong></span>
                <app-search-select [options]="createWorkerTypeOptions" placeholder="Search worker types..."
                  [(selectedId)]="createForm.workerTypeId">
                </app-search-select>
              </div>

              <div class="form-field">
                <span>Supervisor</span>
                <app-search-select [options]="createSupervisorOptions" placeholder="Search supervisors..."
                  [(selectedId)]="createForm.supervisorUserId">
                </app-search-select>
              </div>
            </div>

            <div class="modal-error-banner submit-error" *ngIf="createSubmitError">
              {{ createSubmitError }}
            </div>
          </ng-container>
        </ng-container>
      </div>

      <div class="modal-footer">
        <button class="btn-secondary" type="button" (click)="closeCreateModal()" [disabled]="isCreatingEmployee">
          Cancel
        </button>

        <button class="btn-primary" type="button" (click)="createEmployee()"
          [disabled]="isCreatingEmployee || isCreateModalLoading || !!createModalError">
          {{ isCreatingEmployee ? 'Creating...' : 'Create Employee' }}
        </button>
      </div>
    </div>
  </div>
</div>